import { Injectable } from '@angular/core';
import {
  HttpBackend,
  HttpClient,
  HttpHeaders,
  HttpParams,
} from '@angular/common/http';
import { catchError, map, Observable, Observer, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { SecretService } from './secret.service';
// import { AppConfig } from './config/app.config';

@Injectable({
  providedIn: 'root',
})
export class AdminService {
  [x: string]: any;
  baseUrl: any;
  // siteBaseUrl: any;
  /** Bare HttpClient (no app interceptors) for direct-to-S3 presigned PUTs. */
  private rawHttp: HttpClient;

  constructor(
    private http: HttpClient,
    private secretServ: SecretService,
    httpBackend: HttpBackend,
  ) {
    this.baseUrl = environment.baseUrl;
    this.rawHttp = new HttpClient(httpBackend);
    // this.siteBaseUrl = environment.siteBaseUrl;
  }

  /**
   * Service for register the tanent of CM.
   * Created by SANDIP PAUL
   * @Phantom
   * CreatedOn 03-Dec-2021
   */

  dashboardinprogress(): Observable<any> {
    return this.http.get(this.baseUrl + 'task/inProgessTasksByProject');
  }
  dashboardopentask(): Observable<any> {
    return this.http.get(this.baseUrl + 'task/openTasksByProject');
  }
  dashboardtodaytask(): Observable<any> {
    return this.http.get(this.baseUrl + 'task/todayTasksByProject');
  }
  dashboardcomplete(): Observable<any> {
    return this.http.get(this.baseUrl + 'task/completedTasksByProject');
  }

  getAssignedUsersbysubtask(id: string): Observable<any> {
    const params = new HttpParams().set('id', id);
    return this.http.get(this.baseUrl + 'task/subtask/assigned-users', {
      params,
    });
  }

  assigneesTaskStatusByProject(projectId: string): Observable<any> {
    return this.http.post(
      this.baseUrl + `task/projects/${projectId}/assignees-task-status`,
      {},
    );
  }

  taskStatusCountByProject(projectId: string): Observable<any> {
    return this.http.post(
      this.baseUrl + `task/projects/${projectId}/task-status-count`,
      {},
    );
  }

  listUsers(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/list-users', payload);
  }
  listAdminUser(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/list-admin-user', payload);
  }

  getAllStatus(): Observable<any> {
    return this.http.get(this.baseUrl + 'status/allstatus');
  }

  getmytaskindashboard(): Observable<any> {
    return this.http.get(this.baseUrl + 'task/getTaskStatusSummery');
  }

  createStatus(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'status/createstatus', payload);
  }

  updateStatus(
    id: string,
    payload: { name: string; code: string },
  ): Observable<any> {
    return this.http
      .put(`${this.baseUrl}/status/statusupdate/${id}`, payload)
      .pipe(
        catchError((error) => {
          console.error('Error updating status:', error);
          return throwError(() => error);
        }),
      );
  }

  deleteStatus(id: string): Observable<any> {
    return this.http.delete(`${this.baseUrl}/status/statusdelete/${id}`);
  }

  getAlltaglist(): Observable<any> {
    return this.http.get(this.baseUrl + 'tag/alltag');
  }

  createTag(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'tag/createtag', payload);
  }

  unassignTag(projectId: string, tagId: string): Observable<any> {
    const url = `${this.baseUrl}tag/unassign-tag/${projectId}`;
    return this.http.post(url, { tagId });
  }
  //notification by sandip -------------------------------------------------------------

  // Get all unread notifications for a user
  getAllNotifications(userId: string): Observable<any> {
    return this.http.get(
      `${this.baseUrl}notification/${userId}/get-notification`,
    );
  }

  // Mark a single notification as read
  markNotificationAsRead(notificationId: string): Observable<any> {
    return this.http.post(
      `${this.baseUrl}notification/${notificationId}/read-notification`,
      {},
    );
  }

  // Mark all notifications as read
  markAllNotificationsAsRead(): Observable<any> {
    return this.http.post(
      `${this.baseUrl}notification/read-all-notification`,
      {},
    );
  }

  // Get notification history (already read notifications)
  getNotificationHistory(): Observable<any> {
    return this.http.get(
      `${this.baseUrl}notification/get-notification-history`,
    );
  }

  addTaskGroup(data: { name: string; projectId: string }): Observable<any> {
    return this.http.post(`${this.baseUrl}taskGroup/addTaskGroup`, data);
  }

  // getTaskGroups(projectId: string): Observable<any> {
  //   return this.http.get(
  //     `${this.baseUrl}taskGroup/list?projectId=${projectId}`
  //   );
  // }

  getTaskGroups(projectId: string): Observable<any> {
    return this.http.get(
      `${this.baseUrl}taskGroup/taskGroupList?id=${projectId}`,
    );
  }

  //notification end ---------------------------------------------

  uploadFiles(formData: FormData): Observable<any> {
    // Don't set Content-Type header - let browser set it automatically
    return this.http.post(`${this.baseUrl}/api/files/upload`, formData);
  }
  updateTag(id: string, payload: { name: string }): Observable<any> {
    return this.http.put(`${this.baseUrl}/tag/updatetag/${id}`, payload).pipe(
      catchError((error) => {
        console.error('Error updating tag:', error);
        return throwError(error);
      }),
    );
  }
  deleteTag(id: string): Observable<any> {
    return this.http.delete(`${this.baseUrl}/tag/deletetag/${id}`);
  }

  getallprojectcategory(): Observable<any> {
    return this.http.get(this.baseUrl + 'projectCategory/allprojectcategory');
  }

  createProjectCategory(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'projectCategory/createprojectcategory',
      payload,
    );
  }

  updateProjectTags(payload: {
    projectId: string;
    tags: string[];
  }): Observable<any> {
    return this.http.post(this.baseUrl + 'project/update-tags', payload);
  }

  updateProjectCategory(
    id: string,
    payload: { name: string },
  ): Observable<any> {
    return this.http
      .put(
        `${this.baseUrl}/projectCategory/updateprojectcategory/${id}`,
        payload,
      )
      .pipe(
        catchError((error) => {
          console.error('Error updating project category:', error);
          return throwError(error);
        }),
      );
  }
  deleteProjectCategory(id: string): Observable<any> {
    return this.http.delete(
      `${this.baseUrl}/projectCategory/deleteprojectcategory/${id}`,
    );
  }

  createcompany(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'company/add-company', payload);
  }

  getCompanyList(): Observable<any> {
    return this.http.get(this.baseUrl + 'company/get-all-companies');
  }

  getProjectsByCompanyId(companyId: string): Observable<any> {
    const url = this.baseUrl + `project/company/${companyId}`;
    return this.http.get(url);
  }

  getCompanyDetails(companyId: string): Observable<any> {
    return this.http.get(
      this.baseUrl + `company/get-company-details/${companyId}`,
    );
  }
  updateCompany(id: string, payload: any): Observable<any> {
    return this.http.put(
      `${this.baseUrl}company/update-company/${id}`,
      payload,
    );
  }

  hideTaskFromCustomer(id: string, payload: any): Observable<any> {
    return this.http.patch(`${this.baseUrl}task/hideTask/${id}`, payload);
  }

  updateTaskList(id: any, payload: any): Observable<any> {
    return this.http.put(
      `${this.baseUrl}taskGroup/editTaskGroup/${id}`,
      payload,
    );
  }

  updateComment(
    commentId: string,
    payload: { comment: string },
  ): Observable<any> {
    return this.http.put(
      `${this.baseUrl}comment/comment/${commentId}`,
      payload,
    );
  }

  deleteComment(commentId: string): Observable<any> {
    return this.http.delete(`${this.baseUrl}comment/comment/${commentId}`);
  }

  deleteCompany(id: string): Observable<any> {
    return this.http.delete(`${this.baseUrl}company/delete-company/${id}`);
  }

  deleteTaskList(id: string): Observable<any> {
    return this.http.delete(`${this.baseUrl}taskGroup/deleteTaskGroup/${id}`);
  }

  createProject(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'project/create', payload);
  }

  addTaskComment(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + '/comment/addtaskcomments', payload);
  }
  getTaskComments(taskId: string, sort: string = 'newest'): Observable<any> {
    return this.http.get(
      `${this.baseUrl}comment/comments/${taskId}?sort=${sort}`,
    );
  }
  getalluserlist(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/users');
  }

  getallmemberindashboard(): Observable<any> {
    return this.http.get(this.baseUrl + 'projectUser/all-users-projects-tasks');
  }

  deletedMemberList(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/deleted-member-list', payload);
  }

  restoreMember(id: string): Observable<any> {
    return this.http.post(this.baseUrl + `user/${id}/restore-member`, {});
  }

  deleteMember(id: string): Observable<any> {
    return this.http.post(this.baseUrl + `user/${id}/hard-delete`, {});
  }

  assinguseronprojectcreate(
    projectId: string,
    userIds: string[],
  ): Observable<any> {
    const url = `${this.baseUrl}projectUser/assign?projectId=${projectId}`;
    const payload = { userIds };

    return this.http.post(url, payload);
  }

  getallproject(filter?: string): Observable<any> {
    const params: any = {};

    if (filter && filter !== 'All Projects') {
      if (filter === 'My Projects') {
        params.myProjectsOnly = true;
      } else if (filter === 'Favorite') {
        params.isStarredOnly = true;
      } else if (filter === 'Completed') {
        params.status = 'Completed';
      } else if (filter === 'In Progress') {
        params.status = 'In Progress';
      }
    }

    return this.http.get(this.baseUrl + 'projectUser/all-projects', { params });
  }

  getProjectsWithPagination(params: {
    page: number;
    limit: number;
    filter?: string;
    tagIds?: string[];
    statusIds?: string[];
    sortField?: string;
    sortOrder?: number;
    searchKeyword?: string;
  }): Observable<any> {
    let httpParams = new HttpParams()
      .set('page', params.page.toString())
      .set('limit', params.limit.toString());

    if (params.filter && params.filter !== 'All Projects') {
      if (params.filter === 'My Projects') {
        httpParams = httpParams.set('myProjectsOnly', 'true');
      } else if (params.filter === 'Favorite') {
        httpParams = httpParams.set('isStarredOnly', 'true');
      } else if (params.filter === 'Completed') {
        httpParams = httpParams.set('status', 'Completed');
      } else if (params.filter === 'In Progress') {
        httpParams = httpParams.set('status', 'In Progress');
      }
    }

    if (params.tagIds && params.tagIds.length > 0) {
      params.tagIds.forEach((tagId) => {
        httpParams = httpParams.append('tagIds', tagId);
      });
    }

    if (params.statusIds && params.statusIds.length > 0) {
      params.statusIds.forEach((statusId) => {
        httpParams = httpParams.append('statusIds', statusId);
      });
    }

    if (params.sortField) {
      httpParams = httpParams.set('sortField', params.sortField);
    }

    if (params.sortOrder !== undefined) {
      httpParams = httpParams.set('sortOrder', params.sortOrder.toString());
    }

    // Only add searchKeyword if it exists and is not empty
    if (params.searchKeyword && params.searchKeyword.trim().length > 0) {
      httpParams = httpParams.set('searchKeyword', params.searchKeyword.trim());
    }

    return this.http
      .get(this.baseUrl + 'projectUser/all-projects', { params: httpParams })
      .pipe(
        catchError((error) => {
          console.error('Error in getProjectsWithPagination:', error);
          // Return empty result on error to prevent breaking the UI
          return throwError(() => error);
        }),
      );
  }

  projectList(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'projectUser/projectslist-pagination',
      payload,
    );
  }

  getallprojectfortaskcreate(): Observable<any> {
    return this.http.get(this.baseUrl + 'project/getallproject');
  }

  getProjectById(projectId: string): Observable<any> {
    return this.http.get(
      this.baseUrl + `projectUser/projectdetails/${projectId}`,
    );
  }

  projectteamMembers(projectId: string): Observable<any> {
    return this.http.get(this.baseUrl + `projectUser/by-project/${projectId}`);
  }

  updateProjectTeamMembers(
    projectId: string,
    userIds: string[],
  ): Observable<any> {
    const url = `${this.baseUrl}projectUser/update-team-members?projectId=${projectId}`;
    const payload = { userIds };

    return this.http.post(url, payload);
  }

  deleteproject(id: string): Observable<any> {
    return this.http.delete(`${this.baseUrl}project/delete/${id}`);
  }

  updateProject(id: string, payload: any): Observable<any> {
    return this.http.put(`${this.baseUrl}project/update/${id}`, payload);
  }

  duplicateProject(id: string, name: string): Observable<any> {
    return this.http.post(`${this.baseUrl}projectUser/duplicate/${id}`, {
      name,
    });
  }

  createtask(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'task/tasks', payload);
  }
  getProjectReport(projectId: string): Observable<any> {
    return this.http.get(`${this.baseUrl}project/report/${projectId}`);
  }

  getTaskByProjectId(projectId: any): Observable<any> {
    return this.http.get(this.baseUrl + `task/tasks-list/${projectId}`);
  }

  getTaskByProjectIddetailspage(
    projectId: string,
    page: number,
    size: number,
    filterObj: any = {},
  ): Observable<any> {
    const url = `${this.baseUrl}task/projects/taskList/${projectId}?page=${page}&size=${size}`;
    const payload =
      filterObj && typeof filterObj === 'object' && 'filterObj' in filterObj
        ? filterObj
        : { filterObj };
    return this.http.post(url, payload);
  }

  /**
   * Bulk-creates tasks from an imported spreadsheet. `payload.tasks` is the
   * nested tree built by the Import Tasks dialog.
   */
  importProjectTasks(payload: {
    projectId: string;
    parentTaskId: string | null;
    tasks: any[];
  }): Observable<any> {
    return this.http.post(this.baseUrl + 'task/tasks/import', payload);
  }

  getCompletedTasks(
    projectId: string,
    page: number,
    limit: number,
    taskGroupId?: string,
    search?: string,
  ): Observable<any> {
    let url = `${this.baseUrl}task/projects/${projectId}/completed-tasks?page=${page}&limit=${limit}`;
    if (taskGroupId) url += `&taskGroupId=${taskGroupId}`;
    if (search) url += `&search=${encodeURIComponent(search)}`;
    return this.http.get(url);
  }

  getTaskByUniqueId(projectId: string, uniqueTaskId: string): Observable<any> {
    const url = `${this.baseUrl}task/projects/${projectId}/task/${uniqueTaskId}`;
    return this.http.get(url);
  }

  getGanttChartData(projectId: string, filterObj: any = {}): Observable<any> {
    const url = `${this.baseUrl}task/projects/granttchart/${projectId}`;
    return this.http.post(url, { filterObj });
  }

  // getTasksByGroupAndProject(taskGroupId: any, projectId: any): Observable<any> {
  //   const url = `${this.baseUrl}taskGroup/TaskList-Group/${projectId}`;
  //   const params = new HttpParams().set('projectId', taskGroupId);
  //   return this.http.get(url, { params });
  // }

  getTasksByGroupAndProject(projectId: any, taskGroupId: any): Observable<any> {
    const url = `${this.baseUrl}taskGroup/TaskList-Group/${projectId}`;
    const params = new HttpParams().set('taskGroupId', taskGroupId);
    return this.http.get(url, { params });
  }

  getTaskGroupWithTasks(projectId: string): Observable<any> {
    return this.http.get(
      `${this.baseUrl}/taskGroup/TaskList-Group/${projectId}`,
    );
  }

  updateTask(id: string, payload: any): Observable<any> {
    return this.http.put(`${this.baseUrl}task/tasks/${id}`, payload);
  }

  addTaskTag(
    taskId: string,
    payload: { tagId: string; tagType: 'normal' | 'user'; userId?: string },
  ): Observable<any> {
    return this.http.post(`${this.baseUrl}task/tasks/${taskId}/tags`, payload);
  }

  removeTaskTag(taskId: string, tagEntryId: string): Observable<any> {
    return this.http.delete(
      `${this.baseUrl}task/tasks/${taskId}/tags/${tagEntryId}`,
    );
  }

  updateSubTask(id: string, payload: any): Observable<any> {
    return this.http.put(`${this.baseUrl}task/tasks/${id}`, payload);
  }

  toggleUserTaskCompletion(taskId: string): Observable<any> {
    return this.http.put(
      `${this.baseUrl}task/tasks/toggle-user-completion/${taskId}`,
      {},
    );
  }

  createSubtask(taskId: string, payload: any): Observable<any> {
    return this.http.post(
      `${this.baseUrl}task/tasks/${taskId}/Add-subtasks`,
      payload,
    );
  }

  toggleStarProject(projectId: string, isStarred: boolean): Observable<any> {
    const payload = { isStarred };
    return this.http.patch(
      `${this.baseUrl}projectUser/projects/${projectId}/star`,
      payload,
    );
  }

  getSubtasksByTaskId(taskId: string): Observable<any> {
    return this.http.get(`${this.baseUrl}task/tasks/${taskId}/subtasks`);
  }

  getprojectsbycompanyid(companyId: any): Observable<any> {
    return this.http.get(
      this.baseUrl + `company/get-projects-by-company/${companyId}`,
    );
  }

  dashboardProfileView(payload: { userId: string }): Observable<any> {
    return this.http.post(
      this.baseUrl + 'projectUser/user-projects-tasks',
      payload,
    );
  }

  deleteTaskOrSubtask(id: string): Observable<any> {
    return this.http.delete(`${this.baseUrl}task/tasks/${id}`);
  }

  viewUserId(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/view-user', payload);
  }
  addAdminUser(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/save-admin-user', payload);
  }
  deleteUser(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/delete-user', payload);
  }
  updateUserStatus(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/update-user-status', payload);
  }
  bulkUpdateUser(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/bulk-update-user', payload);
  }
  getSupervisorList(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/list-supervisor-user');
  }
  getEngineerList(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/list-engineer-user');
  }
  // getClientList(): Observable<any> {
  //   return this.http.get(this.baseUrl + 'user/list-client-user');
  // }
  getClientList(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/list-clients');
  }
  getActiveUsersCount(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/get-active-user-count');
  }

  // other users list
  getAllOtherUsers(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/list-other-user');
  }

  getCountryList(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'master/list-country', payload);
  }

  getCurrencyList(payload: any): Observable<any> {
    return this.http.get(this.baseUrl + 'master/get-currency-list', payload);
  }
  changeImage(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/change-profile-pic', payload);
  }
  deleteImage(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/change-profile-pic', payload);
  }

  /** Cover image (presigned direct-to-S3 upload) */
  getCoverUploadUrl(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/cover-upload-url', payload);
  }
  saveCoverImage(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/save-cover-pic', payload);
  }
  /** PUT the raw file straight to S3 via the presigned URL (no app interceptors). */
  uploadFileToPresignedUrl(uploadUrl: string, file: File): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': file.type });
    return this.rawHttp.put(uploadUrl, file, { headers });
  }

  /** client managemant */
  // addClientUser(payload: any): Observable<any> {
  //   return this.http.post(this.baseUrl + 'user/save-client-user', payload);
  // }
  // getClientlist(payload: any): Observable<any> {
  //   return this.http.post(this.baseUrl + 'user/get-client-list', payload);
  // }
  // viewClientlist(payload: any): Observable<any> {
  //   return this.http.post(this.baseUrl + 'user/view-client', payload);
  // }
  // viewClientInfo(payload: any): Observable<any> {
  //   return this.http.post(this.baseUrl + 'user/view-client-info', payload);
  // }
  // updateClientStatus(payload: any): Observable<any> {
  //   return this.http.post(this.baseUrl + 'user/update-client-status', payload);
  // }
  // deleteClient(payload: any): Observable<any> {
  //   return this.http.post(this.baseUrl + 'user/delete-client', payload);
  // }
  // bulkUpdateClient(payload: any): Observable<any> {
  //   return this.http.post(
  //     this.baseUrl + 'user/bulk-update-client-status',
  //     payload
  //   );
  // }

  saveSupervisor(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/save-supervisor-user', payload);
  }
  getSupervisors(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/get-supervisors', payload);
  }
  viewSupervisor(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/view-supervisor', payload);
  }
  deleteSupervisor(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/delete-supervisor', payload);
  }
  updateSupervisorStatus(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'user/update-supervisor-status',
      payload,
    );
  }
  bulkUpdateSupervisor(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'user/bulk-update-supervisor',
      payload,
    );
  }

  saveAreaManager(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'user/save-area-manager-user',
      payload,
    );
  }
  getAreaManagers(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/get-area-managers');
  }
  viewAreaManager(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/view-area-manager', payload);
  }
  deleteAreaManager(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/delete-area-manager', payload);
  }
  updateAreaManagerStatus(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'user/update-area-manager-status',
      payload,
    );
  }
  bulkUpdateAreaManager(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'user/bulk-update-area-manager-status',
      payload,
    );
  }

  saveEngineer(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/save-engineer-user', payload);
  }
  getEngineers(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/get-engineers');
  }
  viewEngineer(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/view-engineer', payload);
  }
  deleteEngineer(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/delete-engineer', payload);
  }
  updateEngineerStatus(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'user/update-engineer-status',
      payload,
    );
  }
  bulkUpdateEngineer(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/bulk-update-engineer', payload);
  }

  updateImage(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/update-image', payload);
  }
  updatePassword(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/update-password', payload);
  }
  resetPassword(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/resetPassword', payload);
  }
  sendQRViaEmail(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/sendQRbyEmail', payload);
  }
  showQR(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/singleUserQR', payload);
  }

  getSamClient(): Observable<any> {
    return this.http.post(this.baseUrl + 'site/fetch-CD-ccsClientBE', {});
  }

  getSamSite(country_code: any, sage_no: any): Observable<any> {
    return this.http.post(this.baseUrl + 'site/fetch-CD-ccsSitesBE', {
      country_code,
      sage_no,
    });
  }

  forgotPass(payload: { email: string }): Observable<any> {
    // console.log(payload);
    return this.http.post(this.baseUrl + 'user/forgot-password', payload);
  }

  resetNewPassword(
    email: string,
    token: string,
    newPassword: string,
  ): Observable<any> {
    return this.http.post(this.baseUrl + 'user/reset-new-password', {
      email,
      token,
      newPassword,
    });
  }

  sendContact(): Observable<any> {
    return this.http.post(this.baseUrl + 'user/send-request-by-email ', {
      _id: this.secretServ.decryptLocalStorageData(
        localStorage.getItem('user_id'),
      ),
      email: this.secretServ.decryptLocalStorageData(
        localStorage.getItem('emailId'),
      ),
    });
  }

  importSupervisor(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/import-supervisor', payload);
  }

  importAreaManager(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/import-area-manager', payload);
  }

  importClient(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/import-client', payload);
  }

  clientSync(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/clientSyncAllData', payload);
  }

  saveOperationManager(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'user/save-operation-manager-user',
      payload,
    );
  }

  saveRole(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/role-change-Users', payload);
  }
  // http://localhost:8000/auth/api/v1/user/role-change-Users

  listOperationManagers(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/list-operation-manager-user');
  }

  deleteOperationManager(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'user/delete-operation-manager-user',
      payload,
    );
  }

  updateOperationManagerStatus(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'user/update-operation-manager-status',
      payload,
    );
  }

  bulkUpdateOperationManagerStatus(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'user/bulk-update-operation-manager-status',
      payload,
    );
  }

  countryWiseClientList(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'user/country-wise-client-list',
      payload,
    );
  }

  listAllClient(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/list-all-client', payload);
  }

  listSuperAdminUser(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/list-super-admin-user');
  }

  clientSupportTicket(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/client-support-ticket', payload);
  }

  /****** Support Manager *******/
  saveSupportManager(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/save-support-manager', payload);
  }

  listSupportManager(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/list-support-manager');
  }

  listActiveSupportManager(): Observable<any> {
    return this.http.get(this.baseUrl + 'master/support-manager-dropdown-list');
  }

  checkClientQEHS(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/check-client-qehs', payload);
  }

  roleDropdownList(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'master/role-dropdown-list', payload);
  }

  syncAllAdmin(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/adminSyncAllData');
  }

  syncAllOpManager(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/OMSyncAllData');
  }

  syncAllSupportManager(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/SMSyncAllData');
  }

  getCalendarData(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/fetch-calender', payload);
  }

  getBCCompanyList(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/BC-companyList');
  }

  getVanTrackingCustomerList(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/vanTracking-customerList');
  }

  getVanTrackingDeviceLocation(
    payload: any,
    accessToken: any,
    token: any,
  ): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        authorization: `Bearer ${accessToken}, Token ${token}`,
      }),
    };
    return this.http.post(
      this.baseUrl + 'user/vanTracking-customer-device-Location',
      payload,
      httpOptions,
    );
  }

  getAllSiteAM(data: any) {
    const payload = { am_emails: [...data] };
    return this.http.post(this.baseUrl + 'user/get-all-site-ams', payload);
  }

  getAllRoles() {
    return this.http.get(this.baseUrl + 'user/all-roles');
  }

  getAllStockWarehouse() {
    return this.http.get(this.baseUrl + 'master/get-stock-warehouse-list');
  }
  createMachine(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'machine/add-machine', payload);
  }
  machineList(params?: any) {
    const queryParams: any = {};
    if (params?.manufacturerId) {
      queryParams.manufacturerId = params.manufacturerId;
    }
    if (params?.machineTypeId) {
      queryParams.machineTypeId = params.machineTypeId;
    }
    return this.http.get(this.baseUrl + 'machine/get-machine-list', {
      params: queryParams,
    });
  }
  deleteMachine(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'machine/delete-machine', payload);
  }
  deleteMachineInstance(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'machine/delete-machine-instance',
      payload,
    );
  }
  updateMachineStatus(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'machine/update-machine-status',
      payload,
    );
  }
  getMachineDetails(machineId: string) {
    return this.http.get(
      this.baseUrl + `machine/get-machine-details/${machineId}`,
    );
  }
  bulkUpdateMachine(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'machine/bulk-update-machine',
      payload,
    );
  }
  addContract(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'manageClient/add-contract', payload);
  }
  contractList(params?: any) {
    const queryParams: any = {};
    if (params?.clientId) {
      queryParams.clientId = params.clientId;
    }
    return this.http.get(this.baseUrl + 'manageClient/get-contract-list', {
      params: queryParams,
    });
  }
  deleteContract(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'manageClient/delete-contract',
      payload,
    );
  }
  updateContractStatus(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'manageClient/update-contract-status',
      payload,
    );
  }
  bulkUpdateContract(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'manageClient/bulk-update-contract',
      payload,
    );
  }
  getContractDetails(contractId: string) {
    return this.http.get(
      this.baseUrl + `manageClient/get-contract-details/${contractId}`,
    );
  }
  addSector(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'manageClient/add-sector', payload);
  }
  sectorList(params?: any) {
    const queryParams: any = {};
    if (params?.contractId) {
      queryParams.contractId = params.contractId;
    }
    if (params?.clientId) {
      queryParams.clientId = params.clientId;
    }
    return this.http.get(this.baseUrl + 'manageClient/get-sector-list', {
      params: queryParams,
    });
  }
  deleteSector(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'manageClient/delete-sector', payload);
  }
  updateSectorStatus(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'manageClient/update-sector-status',
      payload,
    );
  }
  bulkUpdateSector(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'manageClient/bulk-update-sector',
      payload,
    );
  }
  getSectorDetails(sectorId: string) {
    return this.http.get(
      this.baseUrl + `manageClient/get-sector-details/${sectorId}`,
    );
  }
  /** client managemant */
  addClient(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'manageClient/add-client', payload);
  }
  clientList() {
    return this.http.get(this.baseUrl + 'manageClient/get-client-list');
  }
  deleteClient(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'manageClient/delete-client', payload);
  }
  updateClientStatus(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'manageClient/update-client-status',
      payload,
    );
  }
  bulkUpdateClient(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'manageClient/bulk-update-client',
      payload,
    );
  }
  getClientDetails(clientId: string) {
    return this.http.get(
      this.baseUrl + `manageClient/get-client-details/${clientId}`,
    );
  }

  // getAllSite(): Observable<any> {
  //   return this.http.get(this.baseUrl + 'site/get-all-site');
  // }
  getAllSite(params?: any) {
    const queryParams: any = {};
    if (params?.cityName) {
      queryParams['cityName'] = params.cityName;
    }
    if (params?.clientId) {
      queryParams.clientId = params.clientId;
    }
    if (params?.countryId) {
      queryParams.countryId = params.countryId;
    }
    return this.http.get(this.baseUrl + 'site/get-all-site', {
      params: queryParams,
    });
  }

  siteStatusChange(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'site/site-status-change', payload);
  }

  getSingleSite(params: { _id: string }) {
    const queryParams: { _id: string } = {
      _id: params._id ? params._id : '',
    };
    return this.http.get(this.baseUrl + 'site/get-single-site', {
      params: queryParams,
    });
  }

  getAreaManagerList(params?: any) {
    const queryParams: any = {};
    if (params?.clientId) {
      queryParams.clientId = params.clientId;
    }
    return this.http.get(this.baseUrl + 'site/get-areaManager-list', {
      params: queryParams,
    });
  }

  getCity(clientId: string, countryIds: string): Observable<any> {
    const queryParams = new HttpParams()
      .set('clientId', clientId)
      .set('countryIds', countryIds);

    return this.http.get(this.baseUrl + 'site/get-city', {
      params: queryParams,
    });
  }
  updateAreaManager(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'site/update-site-area-manger',
      payload,
    );
  }
  addManufacturer(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'machine/add-manufacturer', payload);
  }
  getAllManufacturer() {
    return this.http.get(this.baseUrl + 'machine/get-manufacturer-list');
  }
  deleteManufacturer(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'machine/delete-manufacturer',
      payload,
    );
  }
  updateManufacturerStatus(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'machine/update-manufacturer-status',
      payload,
    );
  }
  bulkUpdateManufacturer(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'machine/bulk-update-manufacturer',
      payload,
    );
  }
  getManufacturerDetails(manufacturerId: string) {
    return this.http.get(
      this.baseUrl + `machine/get-manufacturer-details/${manufacturerId}`,
    );
  }

  addMachineType(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'machine/add-machinetype', payload);
  }
  getAllMachineType() {
    return this.http.get(this.baseUrl + 'machine/get-machine-type-list');
  }
  deleteMachinetype(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'machine/delete-machinetype', payload);
  }
  updateMachinetypeStatus(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'machine/update-machinetype-status',
      payload,
    );
  }
  bulkUpdateMachinetype(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'machine/bulk-update-machinetype',
      payload,
    );
  }
  getMachinetypeDetails(machinetypeId: string) {
    return this.http.get(
      this.baseUrl + `machine/get-machinetype-details/${machinetypeId}`,
    );
  }
  getAllSiteMachineDetails(site_id: string) {
    return this.http.get(
      this.baseUrl + `machine/get-site-machine-details/${site_id}`,
    );
  }

  addSiteMachine(payload: any) {
    return this.http.post(this.baseUrl + 'machine/add-machine-fields', payload);
  }

  deleteSiteMachine(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'machine/delete-site-machine',
      payload,
    );
  }

  // Devadatta
  getClientsAc(payload: any): Observable<any> {
    console.log('>>>>>>>>>>>>>>>>', payload);
    return this.http.post(
      this.baseUrl + 'manageClient/get-client-list-ac',
      payload,
    );
  }

  getNextJobID() {
    return this.http.post(this.baseUrl + 'jobs/get-next-job-id', {});
  }
  getClientContractList(clientId: string) {
    return this.http.post(
      this.baseUrl + `manageClient/client/${clientId}/contracts`,
      null,
    );
  }
  getClientCountryList(clientId: string) {
    return this.http.post(
      this.baseUrl + `manageClient/client/${clientId}/countries`,
      null,
    );
  }

  getClientSiteList(clientId: string, params?: any) {
    return this.http.post(
      this.baseUrl + `manageClient/client/${clientId}/sites`,
      params,
    );
  }
  getMultiClientSiteList(clientIds: string, params?: any) {
    return this.http.post(this.baseUrl + `manageClient/client-sites`, {
      clientIds,
      ...params,
    });
  }

  createJob(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'jobs/create', payload);
  }

  getJobsList(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'jobs/get-jobs', payload);
  }
  getExportJobsList(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'jobs/export-jobs', payload);
  }

  getJobDetails(jobId: string, params?: any): Observable<any> {
    return this.http.post(this.baseUrl + `jobs/${jobId}/details`, params);
  }
  updateJob(jobId: string, payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `jobs/${jobId}/update`, payload);
  }

  importSite(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'site/save-bulk-site', payload);
  }

  importBulkMachineSite(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'machine/import-site-machine',
      payload,
    );
  }

  deleteJob(jobId: string): Observable<any> {
    return this.http.post(this.baseUrl + `jobs/${jobId}/delete`, {});
  }

  attachJobImages(jobId: string, payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + `jobs/${jobId}/attach-images`,
      payload,
    );
  }

  // get all machines of a site
  fetchSiteMachines(siteId: string) {
    return this.http.post(
      this.baseUrl + `jobs/get-site-machines/${siteId}`,
      {},
    );
  }

  attachMachineToJob(jobId: string, payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + `jobs/${jobId}/attach-a-machine`,
      payload,
    );
  }

  detachMachineFromJob(jobId: string, payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + `jobs/${jobId}/detach-a-machine`,
      payload,
    );
  }

  // job machines
  getJobMachines(jobId: string): Observable<any> {
    return this.http.post(this.baseUrl + `jobs/${jobId}/machines`, {});
  }
  // assign-engineer
  assignEngineerToJob(jobId: string, payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + `jobs/${jobId}/assign-engineer`,
      payload,
    );
  }
  // getAllEngineersForJob
  getAllEngineersForJob(jobId: string) {
    return this.http.post(
      this.baseUrl + `jobs/${jobId}/available-engineers`,
      {},
    );
  }

  // getAllEngineersForMultiStepJob
  getAllEngineersForMultiStepJob(payload: { siteId?: string } = {}) {
    return this.http.post(this.baseUrl + 'jobs/all-engineers', payload);
  }

  // getAssignedEngineerLogs
  getAssignedEngineerLogs(jobId: string) {
    return this.http.post(
      this.baseUrl + `jobs/${jobId}/assigned-engineer-logs`,
      {},
    );
  }
  // Job Logs
  getJobLogs(jobId: string) {
    return this.http.post(this.baseUrl + `jobs/${jobId}/logs`, {});
  }

  // all statuses
  getAllStatuses() {
    return this.http.get(this.baseUrl + 'jobs/job-statuses');
  }

  // change job status
  changeJobStatus(jobId: string, payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + `jobs/${jobId}/change-status`,
      payload,
    );
  }

  getDeletedJobsList(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'jobs/get-deleted-jobs', payload);
  }

  // restoreJob
  restoreJob(jobId: string): Observable<any> {
    return this.http.post(this.baseUrl + `jobs/${jobId}/restore`, {});
  }
  // permanentDeleteJob
  permanentDeleteJob(jobId: string): Observable<any> {
    return this.http.post(this.baseUrl + `jobs/${jobId}/permanent-delete`, {});
  }

  getSiteJobDetails(siteId: string, payload: any) {
    return this.http.post(
      this.baseUrl + `jobs/get-site-jobs/${siteId}`,
      payload,
    );
  }

  // work-sessions
  getWorkSessions(jobId: string) {
    return this.http.post(this.baseUrl + `jobs/${jobId}/work-sessions`, {});
  }

  // session-info
  getSessionInfo(jobId: string, sessionId: string) {
    return this.http.post(
      this.baseUrl + `jobs/${jobId}/work-sessions/${sessionId}/info`,
      {},
    );
  }

  getManufacturerAc(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'machine/get-manufacturer-list-ac',
      payload,
    );
  }

  getOpenedJobsListForDashboard(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'jobs/get-opened-jobs', payload);
  }

  getCompletedJobsListForDashboard(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'jobs/get-completed-jobs', payload);
  }

  getDashboardJobs(
    listType: string,
    limit: number,
    params: object = {},
  ): Observable<any> {
    return this.http.post(this.baseUrl + 'jobs/get-dashboard-jobs', {
      listType,
      limit,
      ...params,
    });
  }

  getDashboardJobs2(params: object = {}): Observable<any> {
    return this.http.post(this.baseUrl + 'jobs/get-dashboard-jobs', {
      ...params,
    });
  }

  errorList(params?: any) {
    return this.http.get(this.baseUrl + 'jobs/get-error-list', params);
  }

  addMachineService(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'machine/add-machine-service',
      payload,
    );
  }

  getMachineServiceDetails(id: string): Observable<any> {
    return this.http.get(this.baseUrl + `machine/get-service-details/${id}`);
  }

  getJobServiceDetails(jobId: string): Observable<any> {
    return this.http.get(
      this.baseUrl + `machine/get-job-service-details/${jobId}`,
    );
  }

  deleteServiceDetails(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'machine/delete-service-details',
      payload,
    );
  }

  eolMachineList(params?: any) {
    const queryParams: any = {};
    if (params?.site_id) {
      queryParams.site_id = params.site_id;
    }
    if (params?.machine_id) {
      queryParams.machine_id = params.machine_id;
    }
    return this.http.get(this.baseUrl + 'machine/get-eol-machine-list', {
      params: queryParams,
    });
  }

  updateEolMachineStatus(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'machine/update-eol-machine-status',
      payload,
    );
  }

  //get machineInstance details
  getMachineInstanceDetails(machineInstanceId: string) {
    return this.http.get(
      this.baseUrl + `machine/machine-instance-details/${machineInstanceId}`,
    );
  }

  bulkDeleteSiteMachine(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'machine/bulk-delete-site-machine',
      payload,
    );
  }

  getAllClientSiteDetails(clientId: string) {
    return this.http.get(
      this.baseUrl + `site/get-client-site-details/${clientId}`,
    );
  }

  getPartsRequestDetails(jobId: string): Observable<any> {
    return this.http.get(
      this.baseUrl + `machine/get-parts-request-details/${jobId}`,
    );
  }

  getMachineReplacementDetails(jobId: string): Observable<any> {
    return this.http.get(
      this.baseUrl + `machine/get-machine-replacement-details/${jobId}`,
    );
  }

  getPartNameListAc(query: string, queryParams: any = {}): Observable<any> {
    let params = {
      query,
      ...queryParams,
    };

    return this.http.get(this.baseUrl + `jobs/part-name-ac`, {
      params,
    });
  }

  getUnassignedClientSiteDetails(clientId: string) {
    return this.http.get(
      this.baseUrl + `site/get-unAssigned-client-site-details/${clientId}`,
    );
  }

  getAreaManagerSiteList(id: string) {
    return this.http.get(this.baseUrl + `site/area-manager-site-list/${id}`);
  }

  //Restore client
  restoreClient(clientId: string): Observable<any> {
    return this.http.post(
      this.baseUrl + `manageClient/${clientId}/restore`,
      {},
    );
  }

  //Deleted client list
  deletedClientList() {
    return this.http.get(this.baseUrl + 'manageClient/get-deleted-clients');
  }

  //Serial no list
  getAllSerialNo(machineId: string, type: string | null) {
    let url =
      this.baseUrl + `machine/get-machine-instance-details/${machineId}`;

    if (type) {
      url += `?type=${type}`;
    }

    return this.http.get(url);
  }

  // Add Serial No Form
  addSerialNO(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'machine/add-serialNo', payload);
  }

  // Dashboard
  getCountHighights(): Observable<any> {
    return this.http.post(this.baseUrl + 'admin/dashboard/counts', {});
  }

  getLiveEngineerLocation(): Observable<any> {
    return this.http.post(
      this.baseUrl + 'admin/dashboard/live-engineer-location',
      {},
    );
  }

  getTlsMachineList(params: any = {}): Observable<any> {
    return this.http.post(
      this.baseUrl + 'admin/dashboard/tls-machines',
      params,
    );
  }

  getMachineTypeWiseData(params: any = {}): Observable<any> {
    return this.http.post(
      this.baseUrl + 'admin/dashboard/machine-type',
      params,
    );
  }

  getDashboardSiteData(params: any = {}): Observable<any> {
    return this.http.post(this.baseUrl + 'admin/dashboard/sites', params);
  }

  getExportMachineList(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'machine/export-machines', payload);
  }
  getJobCountsByRange(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'admin/dashboard/job-calendar',
      payload,
    );
  }

  getCountryWiseJobTrendsData(params: any = {}): Observable<any> {
    return this.http.post(
      this.baseUrl + 'admin/dashboard/country-wise-job-trends',
      params,
    );
  }

  siteMachineList(params: any = {}): Observable<any> {
    return this.http.post(this.baseUrl + 'machine/site-machine-list', params);
  }

  importMachine(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'machine/import-machine', payload);
  }

  getWorkShopListData() {
    return this.http.get(this.baseUrl + 'machine/workshop-machine-list');
  }

  getmachineSerialNoData(payload: any) {
    return this.http.post(
      this.baseUrl + 'machine/machine-instance-list',
      payload,
    );
  }

  // job types
  getJobTypes(
    filters: Object = { deletedAt: null, active: 1 },
    orderBy: Record<string, 1 | -1> = { name: 1 },
  ): Observable<any> {
    let params = { filters, orderBy };
    return this.http.post(this.baseUrl + 'jobs/job-types', params);
  }

  createJobType(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'jobs/job-types/create', payload);
  }

  updateJobType(jobTypeId: string, payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + `jobs/job-types/${jobTypeId}/update`,
      payload,
    );
  }

  deleteJobType(jobTypeId: string, payload: any = {}): Observable<any> {
    return this.http.post(
      this.baseUrl + `jobs/job-types/${jobTypeId}/delete`,
      payload,
    );
  }

  blockUnblockJobType(jobTypeId: string, payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + `jobs/job-types/${jobTypeId}/status-change`,
      payload,
    );
  }

  bulkDeleteBlockUnblockJobType(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'jobs/job-types/bulk-update', payload);
  }

  putJobOnhold(jobId: string, payload: any = {}): Observable<any> {
    return this.http.post(
      this.baseUrl + `jobs/${jobId}/put-on-hold-special`,
      payload,
    );
  }

  restoreMachineApi(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'machine/restore-workshop-machine',
      payload,
    );
  }

  assignUnassignLocationApi(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'machine/assign-unassign-site',
      payload,
    );
  }

  bulkAssignUnassignLocationApi(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'machine/bulk-assign-unassign-site',
      payload,
    );
  }

  importAssignSite(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'site/import-assign-site', payload);
  }

  getPatJobList(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'jobs/get-pat-jobs', payload);
  }

  addScheduledPAT(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'site/add-pat-schedule', payload);
  }

  deleteScheduledPAT(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'site/delete-pat-schedule', payload);
  }

  // Parts Management
  createPartsApi(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'parts/add-parts', payload);
  }

  listPartsApi(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'parts/parts-list', payload);
  }

  productGroupDropDownApi(): Observable<any> {
    return this.http.get(this.baseUrl + 'parts/product-group-list');
  }

  updatePartsStatusApi(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'parts/update-part-status', payload);
  }

  deletePartsStatusApi(partId: string): Observable<any> {
    return this.http.post(this.baseUrl + `parts/${partId}/delete-part`, {});
  }

  viewPartsApi(partId: string): Observable<any> {
    return this.http.get(this.baseUrl + `parts/get-part-details/${partId}`);
  }

  bulkUpdatePartsApi(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'parts/bulk-update-part', payload);
  }

  //Prices Management
  createPricesApi(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'parts/add-prices', payload);
  }

  listPricesApi(partId: any): Observable<any> {
    return this.http.get(this.baseUrl + `parts/get-price-details/${partId}`);
  }

  //Quotes Management
  quotesListApi(payload: any) {
    return this.http.post(this.baseUrl + 'quote/quotes-list', payload);
  }

  sendQuotesApi(payload: any) {
    return this.http.post(this.baseUrl + 'quote/save-quote', payload);
  }

  getNextQuoteID() {
    return this.http.post(this.baseUrl + 'quote/get-next-quote-id', {});
  }

  //Manage Leads
  leadList(payload: any) {
    return this.http.post(this.baseUrl + 'leads/lead-list', payload);
  }

  createLead(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'leads/add-lead', payload);
  }

  deleteLead(id: string): Observable<any> {
    return this.http.post(this.baseUrl + `leads/${id}/delete-lead`, {});
  }

  getLeadDetails(id: string) {
    return this.http.get(this.baseUrl + `leads/${id}/view-lead`);
  }

  autoCompleteLeads(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'leads/autoComplete-lead-list',
      payload,
    );
  }

  autoCompleteProjects(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'project/autocomplete-project-list',
      payload,
    );
  }

  autoCompleteTasks(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'task/autocomplete-task-list',
      payload,
    );
  }

  autoCompleteUsers(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'user/autocomplete-user-list',
      payload,
    );
  }

  // KPI Methods
  getKPIs(): Observable<any> {
    return this.http.get(this.baseUrl + 'reports/kpis');
  }

  getFilteredKPIs(filters: any): Observable<any> {
    return this.http.post(this.baseUrl + 'reports/kpis', filters);
  }

  // Get chart data for report dashboard
  getChartsData(): Observable<any> {
    return this.http.get(this.baseUrl + 'reports/charts');
  }

  // Get filtered chart data for report dashboard
  getFilteredChartsData(filters: any): Observable<any> {
    return this.http.post(this.baseUrl + 'reports/charts', filters);
  }

  // Generated Reports (server-side, stored in S3 + DB)
  generateAndSaveReport(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'reports/generated', payload);
  }

  getGeneratedReports(params?: {
    page?: number;
    limit?: number;
    type?: string;
  }): Observable<any> {
    let query = '';
    if (params) {
      const q = Object.entries(params)
        .filter(([, v]) => v !== undefined)
        .map(([k, v]) => `${k}=${v}`)
        .join('&');
      if (q) query = '?' + q;
    }
    return this.http.get(this.baseUrl + 'reports/generated' + query);
  }

  deleteGeneratedReport(id: string): Observable<any> {
    return this.http.delete(this.baseUrl + `reports/generated/${id}`);
  }

  // Scheduled Reports (emailed at a future date/time)
  createScheduledReport(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'reports/schedule', payload);
  }
  getScheduledReports(): Observable<any> {
    return this.http.get(this.baseUrl + 'reports/schedule');
  }
  deleteScheduledReport(id: string): Observable<any> {
    return this.http.delete(this.baseUrl + `reports/schedule/${id}`);
  }

  getProjectTimeLog(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'reports/project-time-log', payload);
  }

  expandProjectTimeLogRow(id: string, payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + `reports/project-time-log/${id}/expand`,
      payload,
    );
  }

  //Deal list
  dealList(payload: any) {
    return this.http.post(this.baseUrl + 'deal/get-all-deals', payload);
  }

  createDeal(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'deal/add-deal', payload);
  }

  // Public methods that don't require authentication
  getPublicTaskList(
    projectId: string,
    page: number,
    size: number,
    filterObj: any = {},
  ): Observable<any> {
    const url = `${this.baseUrl}task/projects/taskList/hideTask/public-view/${projectId}?page=${page}&size=${size}`;
    return this.http.post(url, { filterObj });
  }

  getPublicAllStatus(): Observable<any> {
    return this.http.get(`${this.baseUrl}status/allstatus/public-view`);
  }

  getPublicTaskGroups(projectId: string): Observable<any> {
    return this.http.get(
      `${this.baseUrl}taskGroup/taskGroupList/public-view?id=${projectId}`,
    );
  }

  getPublicAssigneesTaskStatus(projectId: string): Observable<any> {
    return this.http.post(
      `${this.baseUrl}task/projects/${projectId}/assignees-task-status/public-view`,
      {},
    );
  }

  getPublicAllProjects(): Observable<any> {
    return this.http.get(`${this.baseUrl}project/getallproject/public-view`);
  }

  getPublicProjectsByCompany(companyId: string): Observable<any> {
    return this.http.get(
      `${this.baseUrl}project/company/public-view/${companyId}`,
    );
  }

  getPublicTasksByGroup(projectId: string): Observable<any> {
    return this.http.get(
      `${this.baseUrl}taskGroup/TaskList-Group/public-view/${projectId}`,
    );
  }

  getPublicSubtasks(taskId: string): Observable<any> {
    return this.http.get(
      `${this.baseUrl}task/tasks/${taskId}/subtasks/public-view`,
    );
  }

  getPublicTaskComments(
    taskId: string,
    sort: string = 'newest',
  ): Observable<any> {
    return this.http.get(
      `${this.baseUrl}project/comments/${taskId}?sort=${sort}`,
    );
  }
  getprojectsdocuments(projectId: any): Observable<any> {
    return this.http.get(`${this.baseUrl}project/files/${projectId}`);
  }

  getUserTaskCount(projectId: string): Observable<any> {
    return this.http.get(
      `${this.baseUrl}taskUserAssign/project/${projectId}/user/mytaskcount`,
    );
  }

  getTasksByGroup(
    projectId: string,
    page: number = 1,
    size: number = 10,
    taskGroupId?: string,
    filterObj: any = {},
    excludeCompleted: boolean = true,
  ): Observable<any> {
    let url = `${this.baseUrl}task/projects/taskList-alltassks-page-wwithgroupid/${projectId}?page=${page}&size=${size}&excludeCompleted=${excludeCompleted}`;

    if (taskGroupId) {
      url += `&taskGroupId=${taskGroupId}`;
    }

    const payload = { filterObj };

    return this.http.post(url, payload);
  }

  updateEmailPermission(payload: {
    userId: string;
    emailPermission: boolean;
  }): Observable<any> {
    return this.http.post(
      this.baseUrl + 'projectUser/update-email-permission',
      payload,
    );
  }

  getAllUsersForTeam(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/all-user-fetch-forteam');
  }

  getAllTeams(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'team/all', payload);
  }

  createTeam(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'team/create', payload);
  }

  updateTeam(teamId: string, payload: any): Observable<any> {
    return this.http.put(this.baseUrl + `team/update/${teamId}`, payload);
  }

  assignTeamToProject(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'project/assign-team', payload);
  }

  unassignTeamFromProject(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'project/unassign-team', payload);
  }

  removeUserFromProject(projectId: string, userId: string): Observable<any> {
    return this.http.delete(this.baseUrl + 'projectUser/unassign', {
      body: { projectId, userId },
    });
  }

  removeUserFromTask(taskId: string, userId: string): Observable<any> {
    return this.http.delete(
      this.baseUrl + `taskUserAssign/task/${taskId}/assignees`,
      { body: { userId } },
    );
  }

  deleteTeam(teamId: string): Observable<any> {
    return this.http.delete(this.baseUrl + `team/delete/${teamId}`);
  }

  // Dashboard Config APIs
  getMyDashboardConfig(): Observable<any> {
    return this.http.get(this.baseUrl + 'dashboard-config/my-config');
  }
  getAllTeamsDashboardConfig(): Observable<any> {
    return this.http.get(this.baseUrl + 'dashboard-config/all');
  }
  getDashboardConfigByTeam(teamId: string): Observable<any> {
    return this.http.get(this.baseUrl + `dashboard-config/${teamId}`);
  }
  updateDashboardConfig(teamId: string, widgets: any[]): Observable<any> {
    return this.http.put(this.baseUrl + `dashboard-config/${teamId}`, {
      widgets,
    });
  }
  resetDashboardConfig(teamId: string): Observable<any> {
    return this.http.post(
      this.baseUrl + `dashboard-config/${teamId}/reset`,
      {},
    );
  }

  // Dashboard Config Team APIs
  saveDashboardConfigTeam(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'dashboard-config-team/save', payload);
  }
  getDashboardConfigTeamByTeamId(teamId: string): Observable<any> {
    return this.http.get(this.baseUrl + `dashboard-config-team/team/${teamId}`);
  }
  getAllDashboardConfigTeams(): Observable<any> {
    return this.http.get(this.baseUrl + 'dashboard-config-team/all');
  }
  deleteDashboardConfigTeam(teamId: string): Observable<any> {
    return this.http.delete(
      this.baseUrl + `dashboard-config-team/team/${teamId}`,
    );
  }

  // User Appearance (Settings > Appearance) APIs
  getMyAppearance(): Observable<any> {
    return this.http.get(this.baseUrl + 'appearance/my-appearance');
  }
  saveMyAppearance(payload: any): Observable<any> {
    return this.http.put(this.baseUrl + 'appearance/my-appearance', payload);
  }

  // Notification Preferences (Settings > Notifications) APIs
  getMyNotificationPreferences(): Observable<any> {
    return this.http.get(
      this.baseUrl + 'notification-preference/my-preferences',
    );
  }
  saveMyNotificationPreferences(payload: any): Observable<any> {
    return this.http.put(
      this.baseUrl + 'notification-preference/my-preferences',
      payload,
    );
  }

  // Currency APIs (Settings > Finance).
  // Currency is a plain master list — there is no global/active currency. Each
  // budget picks its own, so getActiveCurrency/setActiveCurrency no longer exist.
  getCurrencies(): Observable<any> {
    return this.http.get(this.baseUrl + 'currency/list');
  }
  /** The ISO currencies that may be added — the Add Currency dropdown's options. */
  getCurrencyCatalogue(): Observable<any> {
    return this.http.get(this.baseUrl + 'currency/catalogue');
  }
  createCurrency(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'currency/create', payload);
  }
  updateCurrency(id: string, payload: any): Observable<any> {
    return this.http.put(this.baseUrl + 'currency/update/' + id, payload);
  }
  deleteCurrency(id: string): Observable<any> {
    return this.http.delete(this.baseUrl + 'currency/delete/' + id);
  }

  // Budget APIs (Settings > Budget)
  getBudgets(): Observable<any> {
    return this.http.get(this.baseUrl + 'budget/list');
  }
  getBudgetStats(): Observable<any> {
    return this.http.get(this.baseUrl + 'budget/stats');
  }
  /** Finance Dashboard "Budget Overview": per-type counts + invoiced, and coverage. */
  getBudgetOverview(): Observable<any> {
    return this.http.get(this.baseUrl + 'budget/overview');
  }
  getBudgetByProject(projectId: string): Observable<any> {
    return this.http.get(this.baseUrl + 'budget/by-project/' + projectId);
  }
  createBudget(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'budget/create', payload);
  }
  updateBudget(id: string, payload: any): Observable<any> {
    return this.http.put(this.baseUrl + 'budget/update/' + id, payload);
  }
  deleteBudget(id: string): Observable<any> {
    return this.http.delete(this.baseUrl + 'budget/delete/' + id);
  }

  // Budget Type master APIs
  getBudgetTypes(): Observable<any> {
    return this.http.get(this.baseUrl + 'budget/type/list');
  }
  createBudgetType(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'budget/type/create', payload);
  }
  updateBudgetType(id: string, payload: any): Observable<any> {
    return this.http.put(this.baseUrl + 'budget/type/update/' + id, payload);
  }
  deleteBudgetType(id: string): Observable<any> {
    return this.http.delete(this.baseUrl + 'budget/type/delete/' + id);
  }

  // Invoice APIs (Finance > Invoice)
  getInvoices(): Observable<any> {
    return this.http.get(this.baseUrl + 'invoice/list');
  }
  /**
   * Preview only — the real number is assigned server-side on create. It carries
   * the project code and the invoice date, so both are needed to preview it.
   */
  getNextInvoiceNumber(
    opts: { projectId?: string; invoiceDate?: any } = {},
  ): Observable<any> {
    let params = new HttpParams();
    if (opts.projectId) params = params.set('projectId', opts.projectId);
    if (opts.invoiceDate) {
      params = params.set(
        'invoiceDate',
        new Date(opts.invoiceDate).toISOString(),
      );
    }
    return this.http.get(this.baseUrl + 'invoice/next-number', { params });
  }
  /**
   * What can be billed on this project for this period. The shape depends on the
   * budget type: hourly → time logs grouped by task; monthly/yearly → the
   * pro-rated retainer; fixed → just the fee.
   */
  getBillingPreview(
    projectId: string,
    startDate?: any,
    endDate?: any,
  ): Observable<any> {
    let params = new HttpParams();
    if (startDate)
      params = params.set('startDate', new Date(startDate).toISOString());
    if (endDate)
      params = params.set('endDate', new Date(endDate).toISOString());
    return this.http.get(
      this.baseUrl + 'invoice/billing-preview/' + projectId,
      {
        params,
      },
    );
  }
  getInvoiceById(id: string): Observable<any> {
    return this.http.get(this.baseUrl + 'invoice/' + id);
  }
  createInvoice(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'invoice/create', payload);
  }
  updateInvoice(id: string, payload: any): Observable<any> {
    return this.http.put(this.baseUrl + 'invoice/update/' + id, payload);
  }
  deleteInvoice(id: string): Observable<any> {
    return this.http.delete(this.baseUrl + 'invoice/delete/' + id);
  }
  updateInvoiceStatus(id: string, status: string): Observable<any> {
    return this.http.patch(this.baseUrl + 'invoice/status/' + id, { status });
  }
  /** Generates (or reuses) the invoice PDF on S3 and returns its URL. */
  getInvoicePdf(id: string): Observable<any> {
    return this.http.get(this.baseUrl + 'invoice/pdf/' + id);
  }
  /** Emails the invoice PDF. Omit `recipients` to use the ones saved on the invoice. */
  sendInvoiceEmail(id: string, recipients?: string[]): Observable<any> {
    return this.http.post(
      this.baseUrl + 'invoice/send/' + id,
      recipients ? { recipients } : {},
    );
  }
  /** Finance Dashboard summary cards (Total Invoiced / Paid / Pending / Overdue). */
  getFinanceDashboardStats(): Observable<any> {
    return this.http.get(this.baseUrl + 'invoice/dashboard-stats');
  }
  /** Finance Dashboard period-filtered panels (doughnut / top clients / inflow). */
  getFinanceDashboardSections(
    statusPeriod: string,
    clientsPeriod: string,
    cashflowPeriod: string,
  ): Observable<any> {
    const params = new HttpParams()
      .set('statusPeriod', statusPeriod)
      .set('clientsPeriod', clientsPeriod)
      .set('cashflowPeriod', cashflowPeriod);
    return this.http.get(this.baseUrl + 'invoice/dashboard-sections', {
      params,
    });
  }
  /** Global invoice PDF design settings (header colour). */
  getInvoiceConfig(): Observable<any> {
    return this.http.get(this.baseUrl + 'invoice/config');
  }
  /** Update the invoice PDF design settings. Privileged roles only (server-enforced). */
  saveInvoiceConfig(payload: {
    headerColor?: string;
    headerTextColor?: string;
  }): Observable<any> {
    return this.http.put(this.baseUrl + 'invoice/config', payload);
  }

  // Schedule Category APIs
  getAllScheduleCategories(): Observable<any> {
    return this.http.get(this.baseUrl + 'scheduleCategory/allschedulecategory');
  }

  createScheduleCategory(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'scheduleCategory/createschedulecategory',
      payload,
    );
  }

  updateScheduleCategory(
    id: string,
    payload: { name: string; code: string; colorCode?: string },
  ): Observable<any> {
    return this.http
      .put(
        `${this.baseUrl}scheduleCategory/schedulecategoryupdate/${id}`,
        payload,
      )
      .pipe(
        catchError((error) => {
          console.error('Error updating schedule category:', error);
          return throwError(() => error);
        }),
      );
  }

  deleteScheduleCategory(id: string): Observable<any> {
    return this.http.delete(
      `${this.baseUrl}scheduleCategory/schedulecategorydelete/${id}`,
    );
  }

  // Schedule APIs
  createSchedule(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'schedule/create', payload);
  }

  getAllSchedules(params?: any): Observable<any> {
    const payload: any = {};
    if (params?.startDate) payload.startDate = params.startDate;
    if (params?.endDate) payload.endDate = params.endDate;
    if (params?.category) payload.category = params.category;
    if (params?.calendarType) payload.calendarType = params.calendarType;
    if (params?.myEventsOnly !== undefined)
      payload.myEventsOnly = params.myEventsOnly;
    if (params?.selectedUserIds) {
      payload.selectedUserIds = Array.isArray(params.selectedUserIds)
        ? params.selectedUserIds
        : String(params.selectedUserIds)
            .split(',')
            .map((id: string) => id.trim())
            .filter(Boolean);
    }
    return this.http.post(this.baseUrl + 'schedule/all', payload);
  }

  getSchedulesByDateRange(
    startDate: string,
    endDate: string,
    extraParams?: any,
  ): Observable<any> {
    const payload: any = {
      startDate,
      endDate,
    };
    if (extraParams?.category) payload.category = extraParams.category;
    if (extraParams?.calendarType)
      payload.calendarType = extraParams.calendarType;
    if (extraParams?.myEventsOnly !== undefined)
      payload.myEventsOnly = extraParams.myEventsOnly;
    if (extraParams?.selectedUserIds) {
      payload.selectedUserIds = Array.isArray(extraParams.selectedUserIds)
        ? extraParams.selectedUserIds
        : String(extraParams.selectedUserIds)
            .split(',')
            .map((id: string) => id.trim())
            .filter(Boolean);
    }
    return this.http.post(this.baseUrl + 'schedule/date-range', payload);
  }

  getScheduleById(id: string): Observable<any> {
    return this.http.get(this.baseUrl + `schedule/${id}`);
  }

  updateSchedule(id: string, payload: any): Observable<any> {
    return this.http.put(this.baseUrl + `schedule/update/${id}`, payload);
  }

  deleteSchedule(id: string): Observable<any> {
    return this.http.delete(this.baseUrl + `schedule/delete/${id}`);
  }

  getMilestonesForCalendar(
    startDate: string,
    endDate: string,
    userIds?: string[],
  ): Observable<any> {
    let params: any = { startDate, endDate };
    if (userIds && userIds.length > 0) params['userIds'] = userIds.join(',');
    return this.http.get(this.baseUrl + `milestone/calendar/range`, { params });
  }

  // Workspace APIs (Settings > Basic Info)
  getWorkspace(): Observable<any> {
    return this.http.get(this.baseUrl + 'workspace');
  }
  updateWorkspace(payload: any): Observable<any> {
    return this.http.put(this.baseUrl + 'workspace', payload);
  }
  syncClientFromController(): Observable<any> {
    return this.http.post(this.baseUrl + 'workspace/sync-client', {});
  }
  getControllerPlans(): Observable<any> {
    return this.http.get(this.baseUrl + 'workspace/plans');
  }
  getBillingHistory(): Observable<any> {
    return this.http.get(this.baseUrl + 'workspace/billing-history');
  }
  /**
   * Added 14 Aug 2026. "Can one more member be added right now?"
   *
   * Read-only. The server answers with the same count and the same limit check
   * that saving a member runs, so a screen can block up front instead of
   * letting someone fill in the whole form and fail on Save.
   *
   * Returns data: { allowed, max, used, remaining, planName, limitMessage }.
   */
  getMemberLimit(): Observable<any> {
    return this.http.get(this.baseUrl + 'workspace/member-limit');
  }
  /** Step 1 of the logo upload — a presigned S3 URL to PUT the file to. */
  getWorkspaceLogoUploadUrl(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'workspace/logo-upload-url', payload);
  }
  /** Step 2 — record the uploaded logo against the workspace. Null clears it. */
  saveWorkspaceLogo(logoUrl: string | null): Observable<any> {
    return this.http.post(this.baseUrl + 'workspace/logo', { logoUrl });
  }
  /**
   * Upload the logo in one call: the file goes to our own server, which puts it
   * on S3 and records it. Added 12 Aug 2026 — replaces the two calls above for
   * uploading, because a browser PUT to S3 needs the bucket's CORS policy to
   * name the site's origin and it only listed localhost:4200. The two methods
   * above are kept: saveWorkspaceLogo(null) is still what clears the logo.
   *
   * The "with-formdata" in the URL is load-bearing. httpconfig.interceptor.ts
   * sets Content-Type: application/json on every request whose URL does not
   * contain that string, which would stop the browser adding its own multipart
   * boundary — the server then fails with "Unexpected token '-', ------WebK...
   * is not valid JSON". No Content-Type is set here on purpose, for the same
   * reason: only the browser can write a correct boundary.
   */
  uploadWorkspaceLogoFile(file: File): Observable<any> {
    const form = new FormData();
    form.append('logo', file);
    return this.http.post(this.baseUrl + 'workspace/logo-with-formdata', form);
  }

  // Task Allocated Percentage APIs
  getTaskAllocatedPercentage(): Observable<any> {
    return this.http.get(this.baseUrl + 'task-allocated-percentage');
  }

  getProjectTaskBreakdown(projectId: string): Observable<any> {
    return this.http.get(
      this.baseUrl + `task-allocated-percentage/project/${projectId}`,
    );
  }

  // Copy / Move a task or subtask (Super Admin, Developer, Admin)
  getCopyMovePreview(taskId: string, targetProjectId: string): Observable<any> {
    const params = new HttpParams().set('targetProjectId', targetProjectId);
    return this.http.get(`${this.baseUrl}task/tasks/${taskId}/move-preview`, { params });
  }

  copyTask(
    taskId: string,
    body: { targetProjectId: string; includeSubtasks?: boolean; parentTaskId?: string | null },
  ): Observable<any> {
    return this.http.post(`${this.baseUrl}task/tasks/${taskId}/copy`, body);
  }

  moveTask(
    taskId: string,
    body: { targetProjectId: string; parentTaskId?: string | null },
  ): Observable<any> {
    return this.http.post(`${this.baseUrl}task/tasks/${taskId}/move`, body);
  }
}
